import { ItemEnum, ItemTypeEnum, PaymentsStatusEnum, PerforationEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PurchaseOrderEntity } from "../../purchase-order/entities/purchase-order-entity";
import { GrnEntity } from "../../grn/entities/grn-entity";
import { PaymentUploads } from "./payment-uploads.entity";

@Entity('payments')
export class Payments{

    @PrimaryGeneratedColumn("increment",{name:'payments_id'})
    paymentsId:number;
   
    @Column("varchar",{
        nullable: true,
        length:150,
        name:"control_number"
    })
    controlNumber:string;

    @Column("varchar",{
      nullable: true,
      length:150,
      name:"payment_code"
  })
  paymentCode:string;

    @Column('int',{
        name:'po_id',
        nullable:true,
      })
      poId:number

      @Column('int',{
        name:'grn_id',
        nullable:true,
      })
      grnId:number

      @Column('enum',{
        name:'material_type',
        enum:ItemEnum
        })
        materialType:ItemEnum;

    @Column('enum',{
        name:'status',
        enum:PaymentsStatusEnum
        })
        status:PaymentsStatusEnum;

        @Column('enum',{
          name:'advance_payment',
          enum:PerforationEnum,
          default:PerforationEnum.NO
          })
          advancePayment:PerforationEnum;
          
        @Column('int',{
          name:'ref_no',
          nullable:true,
        })
        refNo:number

        @Column('decimal',{
          name:'invoice_amount',
      })
      invoiceAmount : number;

    @Column("boolean",{
        default:true,
        name:"is_active"
        })
      isActive:boolean;

      @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;

      @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => PaymentUploads, Upload => Upload.payments, { cascade: true })
    uploadsInfo: PaymentUploads

    @ManyToOne(type =>PurchaseOrderEntity,purchaseOrder =>purchaseOrder.paymentInfo)
    @JoinColumn({name:'po_id'})
    purchaseOrderEntity:PurchaseOrderEntity

    @ManyToOne(type => GrnEntity, grn => grn.paymentsInfo)
    @JoinColumn({ name: 'grn_id' })
    grnEntity: GrnEntity
}